import { QMResultsListItem } from "./QMResultsListItem";
import { Paper, List, Divider } from "@mui/material";

type QMResultsListProps = {
  data: any[];
  handleListSelection: (resultItem: any) => void;
};

export const QMResultsList = (props: QMResultsListProps) => {
  const { data, handleListSelection } = props;

  return (
    <Paper elevation={6}>
      <List
        sx={{
          flex: "0 1 auto",
          minHeight: "65vh",
        }}
      >
        {data &&
          data.map((itemData) => (
            <QMResultsListItem
              key={itemData.SK}
              data={itemData}
              handleListSelection={handleListSelection}
            />
          ))}
      </List>
    </Paper>
  );
};
